import { render, staticRenderFns } from "./fastThings.vue?vue&type=template&id=4a7d5bc0&scoped=true"
import script from "./fastThings.vue?vue&type=script&lang=js"
export * from "./fastThings.vue?vue&type=script&lang=js"
import style0 from "./fastThings.vue?vue&type=style&index=0&id=4a7d5bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d5bc0",
  null
  
)

export default component.exports